/*
 * @Descripttion:
 * @version:
 * @Author: limin
 * @Date: 2021-03-25 19:14:47
 * @LastEditors: limin
 * @LastEditTime: 2021-04-14 21:31:37
 */
import { sys } from '@/apis/request.conf'
export default {
  /**
   * 地址对象转换 服务器-->系统
   * @param {*} addr 服务器返回的地址对象
   */
  address_format_server_to_sys(addr) {
    const {
      id,
      userId,
      receiveName: name,
      phoneNumber: tel,
      province,
      city,
      area: county,
      address: addressDetail,
      postCode,
      isDefault,
      provinceId,
      cityId,
      areaId: areaCode
    } = addr;
    return {
      id,
      userId,
      name,
      tel,
      province,
      city,
      county,
      addressDetail,
      postCode,
      isDefault:Boolean(isDefault),
      provinceId,
      cityId,
      areaCode:areaCode+'',
      address:`${province}${city}${county}${addressDetail}`,
      isActive:false
    };
  },
  /**
   * 地址对象转换 系统->服务
   * @param {*} addr 系统对象
   */
  address_format_sys_to_server(addr) {
    const {
      id,
      addressDetail: address,
      areaCode: areaId,
      city,
      county: area,
      isDefault,
      name: receiveName,
      postalCode,
      province,
      tel: phoneNumber
    } = addr;
    return {
      id,
      address,
      areaId,
      city,
      area,
      isDefault:Number(isDefault),
      receiveName,
      postalCode,
      province,
      phoneNumber
    };
  },
  // getSymsStoredConfig() {
  //   const systemConfig = window.vm.$store.getters['common/systemConfig'];
  //   return window.vm && systemConfig;
  // },
  // getSymsStoredData() {
  //   return window.vm && Object.assign(window.vm.$store.getters['common/systemInfo'], sys);
  // },
  // clearAuthInfo() {
  //   window.vm && window.vm.$store.dispatch('common/clearAuthInfo');
  // },
  // setSymsInfo(params) {
  //   window.vm && window.vm.$store.dispatch('common/setSystemInfo', params);
  // },
  get ids() {
    return window.vm.$store.getters['common/sysCfg'];
  }
};
